// Module
var code = "<h2 id=\"account-authorizations\">Account Authorizations</h2> <p>Learn about the different types of third party contacts. </p> ";
// Exports
export default code;